// Route path constants
export const ROUTES = {
  // Public routes (no auth required)
  HOME: '/',
  LOGIN: '/login',
  CALLBACK: '/callback',
  LOGOUT: '/logout',
  GUARDIAN_LINK_RESOLVE: '/guardian-link/resolve',

  // Auth required routes
  SIGNUP: '/signup',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  PLAY: '/play',

  // Child routes
  CHILD_LINK_REQUEST: '/link-guardian',
  CHILD_LINK_PENDING: '/link-pending',

  // Guardian routes (adult only)
  GUARDIAN_DASHBOARD: '/guardian',
  GUARDIAN_CHILD: '/guardian/child/:childId',
  GUARDIAN_REQUESTS: '/guardian/requests',
  GUARDIAN_LINK_COMPLETE: '/guardian-link/complete',
} as const

// Route metadata
export interface RouteConfig {
  path: string
  requiresAuth: boolean
  requiresProfile: boolean
  profileType?: 'CHILD' | 'ADULT' | null
  title: string
}

export const routeConfigs: Record<string, RouteConfig> = {
  [ROUTES.HOME]: {
    path: ROUTES.HOME,
    requiresAuth: false,
    requiresProfile: false,
    title: 'Welcome',
  },
  [ROUTES.SIGNUP]: {
    path: ROUTES.SIGNUP,
    requiresAuth: true,
    requiresProfile: false, // Needs auth but no profile yet
    title: 'Create Account',
  },
  [ROUTES.PROFILE]: {
    path: ROUTES.PROFILE,
    requiresAuth: true,
    requiresProfile: true,
    title: 'My Profile',
  },
  [ROUTES.SETTINGS]: {
    path: ROUTES.SETTINGS,
    requiresAuth: true,
    requiresProfile: true,
    title: 'Settings',
  },
  [ROUTES.PLAY]: {
    path: ROUTES.PLAY,
    requiresAuth: true,
    requiresProfile: true,
    title: 'Play',
  },
  [ROUTES.GUARDIAN_DASHBOARD]: {
    path: ROUTES.GUARDIAN_DASHBOARD,
    requiresAuth: true,
    requiresProfile: true,
    profileType: 'ADULT',
    title: 'Guardian Dashboard',
  },
  [ROUTES.CHILD_LINK_REQUEST]: {
    path: ROUTES.CHILD_LINK_REQUEST,
    requiresAuth: true,
    requiresProfile: true,
    profileType: 'CHILD',
    title: 'Link Guardian',
  },
  [ROUTES.CHILD_LINK_PENDING]: {
    path: ROUTES.CHILD_LINK_PENDING,
    requiresAuth: true,
    requiresProfile: true,
    profileType: 'CHILD',
    title: 'Waiting for Guardian',
  },
  [ROUTES.GUARDIAN_LINK_RESOLVE]: {
    path: ROUTES.GUARDIAN_LINK_RESOLVE,
    requiresAuth: false, // Public access with token validation
    requiresProfile: false,
    title: 'Guardian Link',
  },
  [ROUTES.GUARDIAN_LINK_COMPLETE]: {
    path: ROUTES.GUARDIAN_LINK_COMPLETE,
    requiresAuth: true,
    requiresProfile: true,
    profileType: 'ADULT',
    title: 'Link Complete',
  },
}
